export const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700;9..40,800&display=swap');
  :root {
    --bg-0: #06090f; --bg-1: #0c1220; --bg-2: #131c30; --bg-3: #1a2540;
    --text-1: #eaf0ff; --text-2: #8896b3; --text-3: #4a5978;
    --accent: #4f8fff; --green: #34d399; --green-dim: #062e1f;
    --red: #f87171; --red-dim: #2e0a0a; --amber: #fbbf24; --amber-dim: #2e1f05; --purple: #a78bfa;
  }
  * { box-sizing: border-box; -webkit-tap-highlight-color: transparent; margin: 0; padding: 0; }
  html, body {
    font-family: 'DM Sans', -apple-system, sans-serif;
    background: var(--bg-0); color: var(--text-1);
    overscroll-behavior: none; -webkit-font-smoothing: antialiased;
    height: 100%; overflow: hidden; touch-action: manipulation;
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button { -webkit-appearance: none; }
  input[type=number] { -moz-appearance: textfield; appearance: textfield; }
  ::-webkit-scrollbar { display: none; }
  textarea:focus, input:focus, select:focus { outline: none; }
  input, textarea, select { font-size: 16px !important; }
  .fade-in { animation: fadeIn 0.2s ease-out; }
  @keyframes fadeIn { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }
  .slide-up { animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1); }
  @keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
`;

export const s = {
  card: { background: "linear-gradient(145deg, #111b2e, #0d1526)", border: "1px solid rgba(255,255,255,0.04)", borderRadius: 16 },
  cardGlow: { boxShadow: "0 0 0 1px rgba(79,143,255,0.06), 0 8px 32px rgba(0,0,0,0.25)" },
  btnP: { background: "linear-gradient(135deg, #4f8fff, #3366cc)", color: "#fff", border: "none", fontWeight: 700, borderRadius: 14, cursor: "pointer", fontFamily: "inherit", WebkitUserSelect: "none", userSelect: "none" },
  btnG: { background: "var(--bg-2)", border: "1px solid rgba(255,255,255,0.06)", color: "var(--text-2)", fontWeight: 600, borderRadius: 12, cursor: "pointer", fontFamily: "inherit", WebkitUserSelect: "none", userSelect: "none" },
  label: { fontSize: 11, fontWeight: 700, color: "var(--text-3)", textTransform: "uppercase", letterSpacing: 0.6, marginBottom: 6 },
  inp: { width: "100%", padding: "12px 14px", borderRadius: 14, fontSize: 16, fontWeight: 700, background: "var(--bg-2)", color: "var(--text-1)", border: "1px solid rgba(255,255,255,0.06)", outline: "none", fontFamily: "inherit" },
};
